import styles from './ItemDetailModal.module.css';
import { useEffect, useState } from 'react';
import api from '../../../../../api';

const ItemDetailModal = ({item, account, setInfoModalPage, setIsHotModalShown}) => {
      const [isProcessing, setIsProcessing] = useState(false);

      async function whenPurchaseButtonClicked() {
            if (isProcessing) return;

            if(!canPurchase()){
                  const confirm = window.confirm(`아직 HP가 부족해요..!\n\n지금 바로 HP를 모으러 가볼까요?`);
                  if(confirm){
                        setInfoModalPage(0);
                        setIsHotModalShown(true);
                  }
                  return;
            }

            if(item.brand_name=='HOTPLE'){
                  alert(`아직은 구매가 불가능한 상품이에요!\n\n추후, 제휴 매장 할인 기능 업데이트 시 안내드릴게요😉`);
                  return;
            }

            try {
                  // 기본 입력창으로 전화번호 받기
                  let phone = window.prompt('쿠폰을 받을 휴대폰 번호 (예: 01012345678)');
                  if (phone === null) { // 사용자가 취소함
                        return;
                  }

                  // 하이픈 포함 모든 비숫자 제거 -> 숫자만 남김
                  phone = String(phone).replace(/\D/g, '');

                  // 형식 검증: 01로 시작 + 총 10~11자리
                  if (!/^01\d{8,9}$/.test(phone)) {
                        alert('전화번호 형식이 올바르지 않습니다.\n\n예: 01012345678');
                        return;
                  }

                  const payHP = parseInt(item.sale_price * (100 - getDiscountRate(item)) / 100 / 10) * 10;
                  const ok = window.confirm(
                        `입력된 전화번호:\n${phone}\n\n${payHP.toLocaleString()} HP가 소모되며\n교환 후 환불은 어려워요.\n\n지금 교환 하시겠어요?`
                  );
                  if (!ok) return;

                  setIsProcessing(true);
                  // 서버로도 하이픈 없는 숫자만 전달
                  const { data } = await api.post('/shop/items/purchase', {
                        goods_code: item.goods_code,
                        phone_no: phone,
                  });

                  if (data?.success) {
                        alert('🎁교환 성공🎁\n\n*문자 수신까지 다소 시간이 소요될 수 있습니다.');
                        setInfoModalPage(3);
                  } else {
                        alert(data?.error || '교환에 실패했어요. 잠시 후 다시 시도해주세요.');
                  }
            } catch (e) {
                  alert(e?.response?.data?.error || e.message || '요청 중 오류가 발생했습니다.');
            } finally {
                  window.requestUpdate();
                  setIsProcessing(false);
            }
      }

      function getDiscountRate(){
            return item.goods_type_dtl_nm=='핫플' ? item.discount_rate : Math.min(account.level,5);
      }

      function canPurchase(){
            return account.hp >= (parseInt(item.sale_price * (100-getDiscountRate(item))/100/10)*10);
      }

      useEffect(()=>{
            window.requestUpdate();
      },[]);

      return (
            <div className={styles.container}>
                  <div className={styles.contents}>
                        <div className={styles.titleFrame}>
                              <div className={styles.itemName}>{item.goods_name}</div>
                              <div className={styles.itemName2}>를 교환할까요?</div>
                        </div>
                        <img className={styles.itemImage} src={item.goods_img_b}/>
                        <div className={styles.itemContent}>{item.content}</div>
                        <div className={styles.priceFrame}>
                              <div className={styles.priceRow}>
                                    <div className={styles.key}>상품 가격: </div>
                                    <div className={styles.itemprice}>
                                          <div className={styles.discountprice}>{(parseInt(item.sale_price * (100-getDiscountRate(item))/100/10)*10).toLocaleString()} HP</div>
                                          {getDiscountRate(item)>0 && <div className={styles.price}>{item.sale_price.toLocaleString()}HP</div>}
                                          {getDiscountRate(item)>0 && <div className={styles.discountrate}>↓{getDiscountRate(item)}%</div>}
                                    </div>
                              </div>    
                              <div className={styles.priceRow}>
                                    <div className={canPurchase() ? styles.key : styles.keyDisabled}>보유 HP : </div>
                                    <div className={styles.itemprice}>
                                          <div className={canPurchase() ? styles.discountprice : styles.discountpriceDisabled}>{account.hp.toLocaleString()} HP</div>
                                    </div>
                                    {!canPurchase() && <div className={styles.price2}>(HP 보유량이 부족해요..!)</div>}
                              </div>                         
                        </div>
                  </div>
                  <div className={styles.buttonFrame}>
                        <div className={styles.backButton} onClick={()=>setInfoModalPage(0)}>
                              취소
                        </div>
                        <div className={canPurchase() ? styles.purchaseButton : styles.purchaseButtonDisabled} onClick={whenPurchaseButtonClicked}>
                              {canPurchase() ? '교환하기' : '보유 HP 부족'}
                        </div>
                  </div>
                  {isProcessing &&
                        <div className={styles.loadingFrame}>
                              <div className={styles.loader}/>
                              <div className={styles.loadingText}>
                              교환 요청 중...
                              </div>
                        </div>
                  }
            </div>
      );
};

export default ItemDetailModal;